import PopupBodyChart from "../../../../components/map/popup/PopupBodyChart";
import PopupFooter from "../../../../components/map/popup/PopupFooter";
import PopupHeader from "../../../../components/map/popup/PopupHeader";
import APP from "../../../config";
import data from "../data";
import geo from "../geo";
import meta from "../meta";

/**
 * Share of sittings statistic.
 * 
 * @author Adam Janosik, Kristyna Zaklova
 */

const genericPopup = {
    header: {
        component: PopupHeader,
        props: {
            data: data
        }
    },
    body: {
        component: PopupBodyChart,
        props: {
            data: data,
            stats: [
                {
                    title: "Srovnání dle počtu zasedání za volební období 2020-2024 (s výjimkou Prahy)",
                    content: () => {
                        return (
                            <>
                                <p>Za uplynulé volební období se počet zasedání zastupitelstev v jednotlivých krajích pohyboval od <span className="emp"><strong>17</strong></span> do <span className="emp"><strong>45</strong></span>. Nejvíce zasedání proběhlo v <span className="emp"><strong>Libereckém kraji</strong></span> a naopak nejméně v <span className="emp"><strong>Moravskoslezském kraji</strong></span>.</p>
                            </>
                        )
                    },
                    chart: {
                        type: "bar",
                        config: {
                            geo: geo,
                            data: data,
                            categories: meta.pocetZasedani.values,
                            getValue: meta.pocetZasedani.getValue,
                            formatValue: meta.pocetZasedani.formatValue
                        }
                    }
                }
            ]
        }
    },
    footer: {
        component: PopupFooter,
        props: {
            data: data,
            settings: {
                left: {
                    title: {
                        label: "Zdroje:",
                        icon: "pi pi-fw pi-globe"
                    },
                    links: [
                        {
                            label: "Datové sady",
                            value: `${APP.appUrl("kraje")}/datasety`
                        }
                    ]
                },
                right: {
                    title: undefined,
                    links: [
                        meta.route
                    ]
                }
            }
        }
    },
    style: {
        width: '80vw',
        height: '100vh',
        maxWidth: '1200px',
    }
}

const sittingsStats = {
    title: 'Zasedání zastupitelstev',
    content: () => {
        return (
            <>
                Zastupitelstvo se schází podle potřeby, nejméně však <span className="emp">jedenkrát za <strong>3</strong>&nbsp;měsíce</span>, během čtyřletého funkčního období se tedy musí uskutečnit <span className="emp">nejméně <strong>12</strong>&nbsp;zasedání</span>. 
                Ta v souladu se <span className="emp">Zákonem o&nbsp;krajích</span> písemně svolává a&nbsp;řídí typicky hejtman. 
                Frekvence jednání se napříč kraji liší, téměř každý měsíc se jednalo v&nbsp;<span className="emp">kraji Libereckém</span>.
            </>
        )
    },
    chart: {
        id: "mapa-pocet-zasedani",
        type: "regional-choropleth",
        config: {
            geo: geo,
            data: data,
            categories: meta.pocetZasedani.values,
            getValue: meta.pocetZasedani.getValue,
            formatValue: meta.pocetZasedani.formatValue,
            map: {
                defaults: {
                    polygon: {
                        hoverStyle: {
                            fill: "yellow"
                        },
                        popup: {
                            header: {
                                component: PopupHeader,
                                props: {
                                    data: data
                                }
                            },
                            body: {
                                component: PopupBodyChart,
                                props: {
                                    data: data,
                                    stats: [
                                        {
                                            title: "Srovnání dle počtu zasedání za volební období 2020-2024 (s výjimkou Prahy)",
                                            content: () => {
                                                return (
                                                    <>
                                                        <p>Za uplynulé volební období se počet zasedání zastupitelstev v jednotlivých krajích pohyboval od <span className="emp"><strong>17</strong></span> do <span className="emp"><strong>45</strong></span>. Nejvíce zasedání proběhlo v <span className="emp"><strong>Libereckém kraji</strong></span> a naopak nejméně v <span className="emp"><strong>Moravskoslezském kraji</strong></span>.</p>
                                                    </>
                                                )
                                            },
                                            chart: {
                                                type: "bar",
                                                config: {
                                                    geo: geo,
                                                    data: data,
                                                    categories: meta.pocetZasedani.values,
                                                    getValue: meta.pocetZasedani.getValue,
                                                    formatValue: meta.pocetZasedani.formatValue
                                                }
                                            }
                                        }
                                    ]
                                }
                            },
                            footer: {
                                component: PopupFooter,
                                props: {
                                    data: data,
                                    settings: {
                                        left: {
                                            title: {
                                                label: "Zdroje:",
                                                icon: "pi pi-fw pi-globe"
                                            },
                                            links: [
                                                {
                                                    ...meta.url,
                                                    label: "Web kraje",
                                                },
                                                {
                                                    ...meta.urlHlasovaciData,
                                                    label: "Hlasovací data kraje",
                                                }
                                            ]
                                        },
                                        right: {
                                            title: undefined,
                                            links: [
                                                meta.route
                                            ]
                                        }
                                    }
                                }
                            },
                            style: {
                                width: '80vw',
                                height: '100vh',
                                maxWidth: '1200px',
                            }
                        }
                    },
                    capital: {
                        style: {
                            display: "none"
                        }
                    }
                }
            },
        }
    },
    footer: {
        left: {
            title: {
                label: "Zdroje:",
                icon: "pi pi-fw pi-globe"
            },
            links: [
                {
                    label: "Datové sady",
                    value: `${APP.appUrl("kraje")}/datasety`
                }
            ]
        },
        right: {
            title: undefined,
            links: [
                meta.route
            ]
        },
        popup: {
            component: genericPopup
        }
    }
}
export default sittingsStats;